import { STORAGE_KEYS } from 'constants/storageKeys';

import { ApiDocumentationParserResponse } from '@api-platform/admin';
import { parseHydraDocumentation } from '@api-platform/api-doc-parser';
import { API_PATH } from 'config/entrypoint';

import { getHeaders } from './headers';

export async function apiDocumentationParser(): Promise<ApiDocumentationParserResponse> {
  try {
    return await parseHydraDocumentation(API_PATH, { headers: getHeaders });
  } catch (result: any) {
    const { api, response, status, error } = result;

    console.error('apiDocumentationParser: ', result);

    if (status === 401 || status === 403) {
      localStorage.removeItem(STORAGE_KEYS.TOKEN);

      return {
        api,
        response,
        status,
      };
    }

    if (error.response) {
      const errorResponse = await error.response.json();
      const currentError = errorResponse.errors[0];

      throw new Error(`${currentError.title}
        Status: ${currentError.code}
        class: ${currentError.exception.class}
        file: ${currentError.exception.file}
        line: ${currentError.exception.line}`);
    }

    throw result;
  }
}
